import * as React from 'react';
import CartContentContext from './CartContentContext';
import DrawerContent from './DrawerContent';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CartContent({
  noCheckoutButton = false,
  noSuggestions = false,
  openable = false,
  openPreferences,
  preferences,
  hidePanel
}) {
  const contextValue = React.useMemo(() => ({
    noCheckoutButton,
    noSuggestions,
    openPreferences,
    preferences,
    openable,
    hidePanel: openable ? hidePanel : undefined
  }), [noCheckoutButton, noSuggestions, openPreferences, preferences, hidePanel, openable]);
  return /*#__PURE__*/_jsx(CartContentContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(DrawerContent, {})
  });
}